"use client";

import { useEffect, useState } from "react";
import { useWishlistStore } from "@/lib/store/useWishlistStore";
import Link from "next/link";
import { Trash2, ShoppingBag, Heart } from "lucide-react";

export default function WishlistPageClient() {
  const { items, removeItem } = useWishlistStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 space-y-6">
        <div className="w-20 h-20 rounded-full bg-[#111114] border border-[rgba(201,168,76,0.12)] flex items-center justify-center text-[#7A7670]">
          <Heart size={32} />
        </div>
        <div className="text-center space-y-2">
          <h2 className="text-2xl text-[#F4F0E8] font-light">Favori Listeniz Boş</h2>
          <p className="text-[#7A7670]">Beğendiğiniz ürünleri buraya ekleyerek daha sonra kolayca bulabilirsiniz.</p>
        </div>
        <Link 
          href="/products" 
          className="bg-[#C9A84C] text-black px-10 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#F4F0E8] transition-all"
        >
          Keşfetmeye Başla
        </Link>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
      {items.map((item) => (
        <div 
          key={item.id} 
          className="group relative bg-[#111114] border border-[rgba(201,168,76,0.08)] rounded p-4 hover:border-[#C9A84C]/30 transition-all duration-500"
        >
          <button 
            onClick={() => removeItem(item.id)}
            className="absolute top-4 right-4 z-20 w-8 h-8 bg-red-500/10 text-red-500 rounded-full flex items-center justify-center hover:bg-red-500 hover:text-white transition-all"
          >
            <Trash2 size={14} />
          </button>

          <Link href={`/products/${item.slug}`}>
            <div className="relative aspect-[4/5] bg-black/40 mb-6 overflow-hidden flex items-center justify-center rounded-sm">
              <div className="w-16 h-28 relative group-hover:scale-110 transition-transform duration-500">
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-6 h-4 bg-[#C9A84C]/40 border border-[#C9A84C]/40 rounded-t-sm" />
                <div className="absolute inset-0 bg-gradient-to-br from-[#C9A84C]/20 via-[#1A1A1F] to-[#C9A84C]/10 border border-[#C9A84C]/30 rounded-sm" />
              </div>
            </div>
            
            <div className="space-y-3">
              <div>
                <h3 className="font-serif text-xl text-[#F4F0E8] group-hover:text-[#C9A84C] transition-colors">
                  {item.name}
                </h3>
              </div>
              
              <div className="flex justify-between items-center pt-2">
                <div className="font-serif text-xl text-[#C9A84C]">
                  ₺{item.price.toLocaleString('tr-TR')}
                </div>
                <div className="w-8 h-8 border border-[rgba(201,168,76,0.12)] flex items-center justify-center text-[#C9A84C] hover:bg-[#C9A84C] hover:text-black transition-all">
                  <ShoppingBag size={14} />
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}
